/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getRegimenChecklistItems } from 'app/entities/regimen-checklist-item/regimen-checklist-item.reducer';
import { getEntities as getTreatmentCycles } from 'app/entities/treatment-cycle/treatment-cycle.reducer';
import { createEntity, getEntity, reset, updateEntity } from './treatment-cycle-check-list-item.reducer';

export const TreatmentCycleCheckListItemUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const regimenChecklistItems = useAppSelector(state => state.regimenChecklistItem.entities);
  const treatmentCycles = useAppSelector(state => state.treatmentCycle.entities);
  const treatmentCycleCheckListItemEntity = useAppSelector(state => state.treatmentCycleCheckListItem.entity);
  const loading = useAppSelector(state => state.treatmentCycleCheckListItem.loading);
  const updating = useAppSelector(state => state.treatmentCycleCheckListItem.updating);
  const updateSuccess = useAppSelector(state => state.treatmentCycleCheckListItem.updateSuccess);

  const handleClose = () => {
    navigate(`/treatment-cycle-check-list-item${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getRegimenChecklistItems({}));
    dispatch(getTreatmentCycles({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...treatmentCycleCheckListItemEntity,
      ...values,
      checklistItem: regimenChecklistItems.find(it => it.id.toString() === values.checklistItem?.toString()),
      cycle: treatmentCycles.find(it => it.id.toString() === values.cycle?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...treatmentCycleCheckListItemEntity,
          checklistItem: treatmentCycleCheckListItemEntity?.checklistItem?.id,
          cycle: treatmentCycleCheckListItemEntity?.cycle?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="tinyMedicRestApp.treatmentCycleCheckListItem.home.createOrEditLabel"
            data-cy="TreatmentCycleCheckListItemCreateUpdateHeading"
          >
            <Translate contentKey="tinyMedicRestApp.treatmentCycleCheckListItem.home.createOrEditLabel">
              Create or edit a TreatmentCycleCheckListItem
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="treatment-cycle-check-list-item-id"
                  label={translate('tinyMedicRestApp.treatmentCycleCheckListItem.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentCycleCheckListItem.result')}
                id="treatment-cycle-check-list-item-result"
                name="result"
                data-cy="result"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentCycleCheckListItem.resultComment')}
                id="treatment-cycle-check-list-item-resultComment"
                name="resultComment"
                data-cy="resultComment"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentCycleCheckListItem.active')}
                id="treatment-cycle-check-list-item-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentCycleCheckListItem.cursor')}
                id="treatment-cycle-check-list-item-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentCycleCheckListItem.lastUpdated')}
                id="treatment-cycle-check-list-item-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentCycleCheckListItem.microSec')}
                id="treatment-cycle-check-list-item-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentCycleCheckListItem.timestampEntry')}
                id="treatment-cycle-check-list-item-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="treatment-cycle-check-list-item-checklistItem"
                name="checklistItem"
                data-cy="checklistItem"
                label={translate('tinyMedicRestApp.treatmentCycleCheckListItem.checklistItem')}
                type="select"
              >
                <option value="" key="0" />
                {regimenChecklistItems
                  ? regimenChecklistItems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="treatment-cycle-check-list-item-cycle"
                name="cycle"
                data-cy="cycle"
                label={translate('tinyMedicRestApp.treatmentCycleCheckListItem.cycle')}
                type="select"
              >
                <option value="" key="0" />
                {treatmentCycles
                  ? treatmentCycles.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/treatment-cycle-check-list-item"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TreatmentCycleCheckListItemUpdate;
